import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import store from "./store";

Vue.use(Router);

let lang,
    state = store.state;

let router = new Router({
    routes: [
        {
            path: "/",
            name: "home",
            component: Home,
            meta: {
                langKey: "home_page_title"
            },
            children: [
                {
                    path: "password",
                    name: "password",
                    component: () => import("./components/Empty.vue"),
                    children: [
                        {
                            path: "lost",
                            name: "lost",
                            meta: {
                                langKey: "password_lost_page_title",
                                pageLoading: false,
                                parent: "password"
                            },
                            component: () => import("./views/password/Lost.vue")
                        },
                        {
                            path: "reset",
                            name: "reset",
                            meta: {
                                langKey: "password_reset_page_title",
                                isBackBtnShowInToolbar: true,
                                pageLoading: false,
                                parent: "password"
                            },
                            component: () =>
                                import("./views/password/Reset.vue")
                        },
                        {
                            path: "*",
                            redirect: { name: "password" }
                        }
                    ]
                },
                {
                    path: "security",
                    component: () => import("./components/Empty.vue"),
                    children: [
                        {
                            path: "",
                            name: "security",
                            meta: {
                                langKey: "security_page_title",
                                parent: "security"
                            },
                            beforeEnter(to, from, next) {
                                store.commit("CHANGE_AUTH_VERIFIED", "");
                                next();
                            },
                            component: () =>
                                import("./views/security/Index.vue")
                        },
                        {
                            path: "email",
                            name: "email",
                            meta: {
                                isBackBtnShowInToolbar: true,
                                requiresAuth: true,
                                pageLoading: false,
                                parent: "security"
                            },
                            component: () =>
                                import("./views/security/Email.vue")
                        },
                        {
                            path: "mobile",
                            name: "mobile",
                            meta: {
                                isBackBtnShowInToolbar: true,
                                requiresAuth: true,
                                pageLoading: false,
                                parent: "security"
                            },
                            component: () =>
                                import("./views/security/Mobile.vue")
                        },
                        {
                            path: "question",
                            name: "question",
                            meta: {
                                isBackBtnShowInToolbar: true,
                                requiresAuth: true,
                                pageLoading: false,
                                parent: "security"
                            },
                            component: () =>
                                import("./views/security/Question.vue")
                        },
                        {
                            path: "password",
                            name: "verify-password",
                            meta: {
                                langKey: "password_verify_page_title",
                                isBackBtnShowInToolbar: true,
                                pageLoading: false,
                                parent: "security"
                            },
                            beforeEnter(to, from, next) {
                                let hasSetted = state.securities.some(
                                        v => v.setted
                                    ),
                                    hasRedirect =
                                        ["mobile", "email", "question"].indexOf(
                                            to.query.redirect
                                        ) > -1;
                                if (hasSetted || !hasRedirect) {
                                    next({
                                        name: "security"
                                    });
                                } else {
                                    next();
                                }
                            },
                            component: () =>
                                import("./views/security/Password.vue")
                        },
                        {
                            path: "*",
                            redirect: { name: "security" }
                        }
                    ]
                },
                {
                    path: "*",
                    redirect: { name: "home" }
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    store.commit("CHANGE_ROUTE", true);
    store.commit("CHANGE_PAGE_LOADING", true);
    if (!state.pageParent) {
        store.commit("CHANGE_PAGE_PARENT", to.meta.parent);
    }

    if (to.matched.some(record => record.meta.requiresAuth)) {
        let nextName = "verify-password",
            redirect = to.name,
            settedSecurities = store.getters.settedSecurities,
            securityObj = store.getters.securityObj;

        if (from.query.redirect === "reset") {
            redirect = "reset";
        }
        if (state.authVerifiedType) {
            next();
        } else if (!state.securities.length) {
            next({
                name: "security",
                query: to.query
            });
        } else {
            if (securityObj[to.name].setted) {
                nextName = to.name;
            } else if (settedSecurities.length) {
                nextName = settedSecurities[0].type;
            }
            store.commit("CHANGE_AUTH_VERIFIED", "verification");
            next({
                name: nextName,
                query: Object.assign({}, state.params, { redirect })
            });
        }
    } else {
        next();
    }
});

let setPageTitle = to => {
    if (["email", "mobile", "question"].indexOf(to.name) === -1) {
        return;
    }
    let isVerification =
            !state.authVerifiedType ||
            state.authVerifiedType === "verification",
        key;

    switch (to.name) {
        case "email":
            key = isVerification
                ? "email_verify_page_title"
                : "email_reset_page_title";
            break;
        case "mobile":
            key = isVerification
                ? "phone_verify_page_title"
                : "phone_reset_page_title";
            break;
        case "question":
            key = isVerification
                ? "question_verify_page_title"
                : "question_reset_page_title";
            break;
    }
    store.commit("CHANGE_PAGE_TITLE", lang[key]);
};

router.afterEach(to => {
    store.commit("UPDATE_QUERY_PARAMS", to.query);
    lang = store.getters.lang;
    setPageTitle(to);
    if (to.meta) {
        if (to.meta.langKey !== undefined) {
            store.commit("CHANGE_PAGE_TITLE", lang[to.meta.langKey]);
        }
        if (to.meta.pageLoading !== undefined) {
            store.commit("CHANGE_PAGE_LOADING", to.meta.pageLoading);
        }
    }
    store.commit("TOGGLE_TOOLBAR_BACK_BTN", to.meta.isBackBtnShowInToolbar);
    setTimeout(() => {
        store.commit("CHANGE_ROUTE", false);
    }, 500);
});
export default router;
